import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

const VoucherURL = "https://shell.wafr.co/api/" //process.env.REACT_APP_WAFR_VOUCHER_API_URL //"http://localhost:5050/api/" //

export const getOffers = async (operator, amount) => {
  try {
    const response = await axios.get(
      `${VoucherURL}offers?operator=${operator}&amount=${amount}`
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const getAmount = async (voucher) => {

  let url = VoucherURL;
  var payload = {
      "VoucherKey":voucher,
  }
  await firebase.auth().signInAnonymously();
  const user = firebase.auth().currentUser;
  const token = await user.getIdToken();
  //console.log('Anonymous User Token:', token);

  
  try {
    const response = await axios.post(`${url}voucherAmount`,payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        
      },
    });
    if (response.status == 200 && response.data.success == true) {
      console.log(response.data);
      return response.data;
    }
    else{
        return {error : response.data.error, success: false}
    }
  } catch (e) {
    return  {error : "server error", success: false};
  }

};

export const postApiData = async (data) => {

  let url = VoucherURL;
  var payload = {
      "VoucherKey":data.VoucherKey,
      "PhoneNumber" : data.PhoneNumber,
      "Operator":data.Operator,
      "Product":data.Product.toString(),
  }
  console.log(payload);
  await firebase.auth().signInAnonymously();
  const user = firebase.auth().currentUser;
  const token = await user.getIdToken();
  //console.log('Anonymous User Token:', token);

  
  try {
    const response = await axios.post(`${url}voucher`,payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        
      },
    });
    if (response.status == 200 && response.data.success == true) {
      console.log(response.data);
      return response.data;
    }
    else{
        return {error : response.data.error, success: false}
    }
  } catch (e) {
    return  {error : "server error", success: false};
  }

};
